import styled from 'styled-components';

const LogoLeftNavbar = styled.img`
  width: 50px;
  height: 50px;
  margin-right: 20px;
  margin-top: 4px;

`;

export { LogoLeftNavbar }